/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { authHeaders } from "#/modules/auth/idp";

export type DashboardDaywiseData = {
  date: string;
  request_count: number;
  request_unsafe_count: number;
  request_custom_unsafe_count: number;
};

export type DashboardSummary = {
  security_score: number;
  max_response_time_ms: number;
  p95_response_time_ms: number;
  request_unsafe_count: number;
  request_count: number;
  tool_request_count: number;
  total_session_count: number;
  unsafe_request_counts_by_max_risk: Record<string, number>;
  violation_type_counts: Record<string, number>;
  policies_request_counts: Record<string, number>;
};

export type DashboardItem = {
  service_token_name: string;
  division: string;
  summary: DashboardSummary;
  daywise_data: DashboardDaywiseData[];
};

export type DashboardResponse = DashboardItem[];

export default function getDashboard({
  period,
  timezone,
  token,
}: {
  period: number;
  timezone?: string;
  token: string;
}): Promise<InternalResponse<DashboardResponse>> {
  return request()({
    url: "/xecguard/v1/internal/dashboard",
    method: "GET",
    params: {
      period,
      ...(timezone ? { timezone } : {}),
    },
    headers: authHeaders(token),
  }).then(
    (result: AxiosResponse<DashboardResponse>): InternalResponse<DashboardResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.code,
    msg: error.message,
    success: false,
  }));
}
